import type {ReactElement} from 'react';
import React from 'react';
import {BaseTextColorOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-text-color-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromFillOfTextStylesOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromFillOfTextStylesOfActiveItem';

interface TextColorOptionProps {
  onClickColorFill(): void;
  isDisabled?: boolean;
}

export function TextColorOption({isDisabled = false, ...props}: TextColorOptionProps): ReactElement {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const fillType = useGetKeyFromFillOfTextStylesOfActiveItem('fillType');
  const fillColor = useGetKeyFromFillOfTextStylesOfActiveItem('fillColor');

  if (!activeItem || (activeItem && !('textStyles' in activeItem)) || !fillColor || fillType === undefined) {
    throw new Error(`Text Item doesn't have textStyles property`);
  }

  return (
    <BaseTextColorOption
      isDisabled={isDisabled}
      fillObject={{
        fillType,
        fillColor,
      }}
      onClickColorFill={(): void => {
        props.onClickColorFill();
      }}
    />
  );
}
